import React, { Component } from 'react';
import "./Resume.css";

class GoodSonApps extends Component {
   render() {
      return (
         <div className="GoodSonApps">
            <h1 className="text-center section-heading">GoodSon Applications 3/19 - Present</h1>
            <hr/>
            <p>GoodSon Applications, LLC, is a subscription based "Software as a Service" company that 
               provides personal productivity and convenience applications.  Some of the existing and 
               planned applications include a goal oriented and flexible task management system, a 
               personal inventory application, and a shopping list application that supports separate 
               shopping lists for each store a user frequents.
            </p>
            <p>GoodSon Applications uses React on the front end and node.js and the mySQL database on the 
               back end.  All the database tables are in third normal form as defined by E.F. Codd.  GoodSon 
               Applications uses fetch for communication between the front and back ends and also makes use 
               of the bcrypt, crypto-js, sequelize, stripe, Google Recaptcha, and jwt packages among 
               others. 
            </p>
            <p>GoodSon Applications has over thirty custom components including a sliding carousel, a 
               fading carousel, and a modal component using React portals for user alerts.

            </p>
         </div>
      );
   }
} 

export default GoodSonApps;



// WEBPACK FOOTER //
// ./src/components/Resume/GoodSonApps.js